import { FC } from 'react';
import { ProductComparisonBlockStoryblok } from 'storyblok-types';
import { getProductsByParentReferenceKeys } from 'commerce/scayle/product-management';
import { ProductComparisonBlockBody } from './ProductComparisonBlockBody';
import { IComparisonProduct } from './types';

export const ProductComparisonBlock: FC<{
  blok: ProductComparisonBlockStoryblok;
}> = async ({ blok }) => {
  const productIds = blok.products.map(({ id }) => id);
  const { response: products, error } = await getProductsByParentReferenceKeys(
    productIds || [],
  );

  if (error) {
    console.error(error);
    return;
  }

  const productsWithStoryblokData = productIds.reduce<IComparisonProduct[]>(
    (acc, id) => {
      /** need to keep the order of products as in the Storyblok */
      const apiProduct = products?.find(
        (product) => product.referenceKey === id,
      );
      const relevantProduct = blok.products.find(
        ({ id: blokId }) => blokId === id,
      );

      if (apiProduct && relevantProduct) {
        acc.push({
          ...apiProduct,
          productName: relevantProduct?.name,
          productImage: relevantProduct?.image,
          options: relevantProduct?.options,
        });
      }

      return acc;
    },
    [],
  );

  return (
    <ProductComparisonBlockBody
      blok={blok}
      products={productsWithStoryblokData}
    />
  );
};
